<template>
  <div>
    <div @click="click">
      <el-badge :value="noticeNum" :max="99">
        <img
          :src="hornIcon"
          style="height: 18px; cursor: pointer"
          id="hornIcon"
        />
      </el-badge>
    </div>

    <!-- 我的通知公告列表弹框 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="我的通知公告"
      :visible.sync="open"
      append-to-body
    >
      <div>
        <el-form size="small" :inline="true" label-width="98px">
          <el-form-item label="公告标题：">
            <el-input
              v-model="queryParams.noticeTitle"
              size="mini"
              placeholder="请输入"
              clearable
              style="width: 150px"
            />
          </el-form-item>
          <el-form-item label="公告类型：">
            <el-select
              v-model="queryParams.noticeType"
              size="mini"
              placeholder="请选择"
              clearable
              @change="handleQuery"
              style="width: 150px"
            >
              <el-option
                v-for="item in dictionaryList"
                v-if="item.dType === 'SYS_NOTICE_TYPE'"
                :key="item.dKey + ''"
                :label="item.dValue"
                :value="item.dKey + ''"
              >
                <span>{{ item.dValue }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="优先级：">
            <el-select
              v-model="queryParams.priority"
              size="mini"
              placeholder="优先级"
              clearable
              @change="handleQuery"
              style="width: 150px"
            >
              <el-option
                v-for="item in dictionaryList"
                v-if="item.dType === 'SYS_NOTICE_PRIORITY'"
                :key="item.dKey + ''"
                :label="item.dValue"
                :value="item.dKey + ''"
              >
                <span>{{ item.dValue }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="阅读状态：">
            <el-select
              v-model="queryParams.readFlag"
              size="mini"
              placeholder="阅读状态"
              clearable
              @change="handleQuery"
              style="width: 150px"
            >
              <el-option
                v-for="item in dictionaryList"
                v-if="item.dType === 'SYS_NOTICE_READ_FLAG'"
                :key="item.dKey + ''"
                :label="item.dValue"
                :value="item.dKey + ''"
              >
                <span>{{ item.dValue }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button class="button" size="mini" @click="resetQuery"
              >重置
            </el-button>
            <el-button
              class="button"
              size="mini"
              type="primary"
              @click="handleQuery"
            >
              查询
            </el-button>
          </el-form-item>
        </el-form>
      </div>

      <el-table v-loading="loading" :data="noticeList" border>
        <el-table-column
          label="公告标题"
          align="center"
          prop="noticeTitle"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="公告类型"
          align="center"
          prop="noticeType"
          width="80"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            {{ formatDic(scope.row.noticeType, "SYS_NOTICE_TYPE") }}
          </template>
        </el-table-column>
        <el-table-column
          label="优先级"
          align="center"
          prop="priority"
          width="80"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            {{ formatDic(scope.row.priority, "SYS_NOTICE_PRIORITY") }}
          </template>
        </el-table-column>
        <el-table-column
          label="发布人"
          align="center"
          prop="sender"
          width="80"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="发布时间"
          align="center"
          prop="sendTime"
          width="150"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="阅读状态"
          align="center"
          prop="readFlag"
          width="80"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            {{ formatDic(scope.row.readFlag, "SYS_NOTICE_READ_FLAG") }}
          </template>
        </el-table-column>
        <el-table-column
          label="阅读时间"
          align="center"
          prop="readTime"
          width="150"
          :show-overflow-tooltip="true"
        />
        <el-table-column label="操作" align="center" width="80">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              icon="el-icon-info"
              @click="handleDetail(scope.row)"
              >详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination" style="text-align: center; padding-top: 10px">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
        >
        </el-pagination>
      </div>
    </el-dialog>

    <!--详情弹框-->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="详情"
      :visible.sync="openDetail"
      append-to-body
    >
      <el-form ref="form" :disabled="true" :model="form" label-width="100px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="公告标题" prop="noticeTitle">
              <el-input v-model="form.noticeTitle" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="公告类型" prop="noticeType">
              <el-select v-model="form.noticeType" style="width: 100%">
                <el-option
                  v-for="item in dictionaryList"
                  v-if="item.dType === 'SYS_NOTICE_TYPE'"
                  :key="item.dKey + ''"
                  :label="item.dValue"
                  :value="item.dKey + ''"
                >
                  <span>{{ item.dValue }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="优先级" prop="priority">
              <el-radio-group v-model="form.priority">
                <el-radio
                  v-for="item in dictionaryList"
                  v-if="item.dType === 'SYS_NOTICE_PRIORITY'"
                  :key="item.dKey + ''"
                  :label="item.dKey + ''"
                  >{{ item.dValue }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发布人" prop="sender">
              <el-input v-model="form.sender" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发布时间" prop="sendTime">
              <el-input v-model="form.sendTime" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="阅读状态" prop="readFlag">
              <el-radio-group v-model="form.readFlag">
                <el-radio
                  v-for="item in dictionaryList"
                  v-if="item.dType === 'SYS_NOTICE_READ_FLAG'"
                  :key="item.dKey + ''"
                  :label="item.dKey + ''"
                  >{{ item.dValue }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.readFlag === '1'">
            <el-form-item label="阅读时间" prop="readTime">
              <el-input v-model="form.readTime" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="内容" prop="noticeContent">
              <el-input type="textarea" v-model="form.noticeContent"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="read" v-if="form.readFlag === '0'"
          >已 读</el-button
        >
        <el-button @click="cancel">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import
import webSocketClass from "../../../javascript/webSocket";

export default {
  name: "mySysNotice",
  // 注册
  components: {},
  // 定义变量
  data() {
    return {
      dictionaryList: JSON.parse(sessionStorage.getItem("dic")),
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        noticeTitle: null,
        noticeType: null,
        priority: null,
        readFlag: null,
      },
      // 遮罩层
      loading: true,
      currentPage: 1,
      pageSize: 10,
      // 总条数
      totalNum: 0,
      // 公告表格数据
      noticeList: [],
      // 详情弹框
      openDetail: false,
      // 表单参数
      form: {},
      hornIcon: require("@/assets/images/horn.png"),
      noticeNum: null,
    };
  },
  // 父页面传值
  props: {},
  // 计算属性 当里面的数据发生变化时，会自动触发重新计算
  computed: {},
  // 监控data中的变量变化
  watch: {},
  // 方法集合
  methods: {
    click() {
      this.open = true;
      this.handleQuery();
      this.getNotReadSysNoticeCount();
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.currentPage = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParams = {
        noticeTitle: null,
        noticeType: null,
        priority: null,
        readFlag: null,
      };
      this.handleQuery();
    },
    /** 查询公告列表 */
    getList() {
      this.loading = true;
      let that = this;
      that.$http
        .get(
          "/locationbs/system/noticeSend/list?pageNum=" +
            that.currentPage +
            "&pageSize=" +
            that.pageSize,
          that.queryParams
        )
        .then((data) => {
          if (data.code === 200) {
            that.noticeList = data.data.pag;
            that.totalNum = data.data.total;
            that.loading = false;
          } else {
            that.$message({
              type: "warning",
              message: data.message,
            });
          }
        })
        .catch(() => {
          that.$message({
            type: "warning",
            message: "获取我的通知公告列表失败，请稍后再试！",
          });
        });
    },
    handleDetail(data) {
      let that = this;
      that.$http
        .get("/locationbs/system/noticeSend/" + data.id)
        .then((data) => {
          if (data.code === 200) {
            that.form = data.data;
            that.openDetail = true;
          } else {
            that.$message({
              type: "warning",
              message: data.message,
            });
          }
        })
        .catch(() => {
          that.$message({
            type: "warning",
            message: "获取详情失败，请稍后再试！",
          });
        });
    },
    // 取消按钮
    cancel() {
      this.openDetail = false;
    },
    read() {
      let that = this;
      that.$http
        .post("/locationbs/system/noticeSend/" + this.form.id)
        .then((data) => {
          if (data.code === 200) {
            that.openDetail = false;
            that.handleQuery();
            that.getNotReadSysNoticeCount();
          } else {
            that.$message({
              type: "warning",
              message: data.message,
            });
          }
        })
        .catch(() => {
          that.$message({
            type: "warning",
            message: "标记为已读失败，请稍后再试！",
          });
        });
    },
    listenSysNotice() {
      const that = this;
      // 链接websocket
      // eslint-disable-next-line new-cap
      that.ws = new webSocketClass(
        "/locationbs/ws/sysNotice/" +
          JSON.parse(sessionStorage.getItem("userInfo")).uId
      );
      that.ws.getWebSocketMsg((ev) => {
        let data = JSON.parse(ev.data);
        let sendStatus = data.sendStatus;
        let title = "通知公告";
        let message =
          "您有一条新的通知公告【" + data.noticeTitle + "】，请及时查看！";
        if (sendStatus === "2") {
          // 撤销通知公告
          title = "通知公告-撤销";
          message =
            "您有一条通知公告【" + data.noticeTitle + "】，已被撤销，请忽略！";
        }
        that.$notify({
          title: title,
          message: message,
          type: "warning",
          dangerouslyUseHTMLString: true,
          position: "bottom-right",
          // duration: 0
        });
        // 重新获取未读数量
        that.getNotReadSysNoticeCount();
      });
    },
    getNotReadSysNoticeCount() {
      let that = this;
      that.$http
        .get("/locationbs/system/noticeSend/getNotReadSysNoticeCount")
        .then((data) => {
          if (data.code === 200) {
            that.noticeNum = data.data;
            let arr = document.getElementById("hornIcon");
            if (that.noticeNum === 0) {
              arr.classList.remove("ifNotice");
            } else {
              if (!arr.length) {
                arr.classList.add("ifNotice");
              }
            }
          } else {
            that.$message({
              type: "warning",
              message: data.message,
            });
          }
        })
        .catch(() => {
          that.$message({
            type: "warning",
            message: "获取未读通知公告数量失败，请稍后再试！",
          });
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    // 数据字典匹配
    formatDic(e, dicType) {
      for (let i = 0; i < this.dictionaryList.length; i++) {
        if (
          this.dictionaryList[i].dKey + "" === e &&
          this.dictionaryList[i].dType === dicType
        ) {
          return this.dictionaryList[i].dValue;
        }
      }
    },
  },
  // --------------------------- 生命周期 start -----------------------------------
  // 创建完成（可以访问当前this实例）
  created() {},
  // 挂载完成（可以访问DOM元素）
  mounted() {
    this.getNotReadSysNoticeCount();
    // 监听后端通知公告推送
    this.listenSysNotice();
  },
  // 创建之前
  beforeCreate() {},
  // 挂载之前
  beforeMount() {},
  // 更新之前
  beforeUpdate() {},
  // 更新之后
  updated() {},
  // 销毁之前
  beforeDestroy() {},
  // 销毁完成
  destroyed() {},
  // --------------------------- 生命周期 end -----------------------------------
  // 如果页面有keep-alive缓存功能，这个函数会触发
  activated() {},
};
</script>

<style scoped>
.ifNotice {
  -webkit-animation: twinkling 1s infinite ease-in-out;
}
.animated {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
@-webkit-keyframes twinkling {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0.2;
  }
}
@keyframes twinkling {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0.2;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/sysNotice/mySysNotice.vue